// Auto-generated by generatePageRegistry.js
const pageRegistry = {

  "/app/customers/:id": {
    component: () => import("./pages/customers/[id]/page.tsx"),
    meta: {"permissions":["customer:read"]}
  },

  "/app/customers": {
    component: () => import("./pages/customers/page.tsx"),
    meta: {"permissions":["customer:read"]}
  },

  "/app/device-profiles/:id": {
    component: () => import("./pages/device-profiles/[id]/page.tsx"),
    meta: {"permissions":["device_profile:read"],"userType":"System User"}
  },

  "/app/device-profiles/create": {
    component: () => import("./pages/device-profiles/create/page.tsx"),
    meta: {"permissions":["device-profile:create"],"userType":"System User"}
  },

  "/app/device-profiles": {
    component: () => import("./pages/device-profiles/page.tsx"),
    meta: {"permissions":["device_profile:read"],"userType":"System User"}
  },

  "/app/devices/:id": {
    component: () => import("./pages/devices/[id]/page.tsx"),
    meta: {"permissions":["device:read"]}
  },

  "/app/devices/create": {
    component: () => import("./pages/devices/create/page.tsx"),
    meta: {"permissions":["device:create"],"userType":"System User"}
  },

  "/app/devices": {
    component: () => import("./pages/devices/page.tsx"),
    meta: {"permissions":["device:read"]}
  },

  "/forgot-password": {
    component: () => import("./pages/forgot-password/page.tsx"),
    meta: {"path":"/forgot-password","auth":false}
  },

  "/app/integration/email-settings": {
    component: () => import("./pages/integration/email-settings/page.tsx"),
    meta: {"permissions":["email_settings:read"],"userType":"System User"}
  },

  "/app/integration/sms-settings": {
    component: () => import("./pages/integration/sms-settings/page.tsx"),
    meta: {"permissions":["sms_settings:read"],"userType":"System User"}
  },

  "/app/integration/vendor-configs/:id": {
    component: () => import("./pages/integration/vendor-configs/[id]/page.tsx"),
    meta: {"permissions":["vendor_configuration:read"],"userType":"System User"}
  },

  "/app/integration/vendor-configs": {
    component: () => import("./pages/integration/vendor-configs/page.tsx"),
    meta: {"permissions":["vendor_configuration:read"],"userType":"System User"}
  },

  "/login": {
    component: () => import("./pages/login/page.tsx"),
    meta: {"path":"/login","auth":false}
  },

  "/app/notifications": {
    component: () => import("./pages/notifications/page.tsx"),
    meta: {}
  },

  "/app/organizations/:id": {
    component: () => import("./pages/organizations/[id]/page.tsx"),
    meta: {"permissions":["organization:read"]}
  },

  "/app/organizations": {
    component: () => import("./pages/organizations/page.tsx"),
    meta: {"permissions":["organization:read"]}
  },

  "/app/": {
    component: () => import("./pages/page.tsx"),
    meta: {}
  },

  "/app/payment/allocations": {
    component: () => import("./pages/payment/allocations/page.tsx"),
    meta: {"permissions":["payment_allocation:read"]}
  },

  "/app/payment/mpesa-gateways/:id": {
    component: () => import("./pages/payment/mpesa-gateways/[id]/page.tsx"),
    meta: {"permissions":["mpesa_setting:read"]}
  },

  "/app/payment/mpesa-gateways": {
    component: () => import("./pages/payment/mpesa-gateways/page.tsx"),
    meta: {"permissions":["mpesa_setting:read"]}
  },

  "/app/payment/records/:id": {
    component: () => import("./pages/payment/records/[id]/page.tsx"),
    meta: {"permissions":["payment:read"]}
  },

  "/app/payment/records": {
    component: () => import("./pages/payment/records/page.tsx"),
    meta: {"permissions":["payment:read"]}
  },

  "/app/postpaid-billing/adjustments": {
    component: () => import("./pages/postpaid-billing/adjustments/page.tsx"),
    meta: {}
  },

  "/app/postpaid-billing/exceptions": {
    component: () => import("./pages/postpaid-billing/exceptions/page.tsx"),
    meta: {}
  },

  "/app/postpaid-billing/invoices/:id": {
    component: () => import("./pages/postpaid-billing/invoices/[id]/page.tsx"),
    meta: {"permissions":["billing_invoice:read"]}
  },

  "/app/postpaid-billing/invoices": {
    component: () => import("./pages/postpaid-billing/invoices/page.tsx"),
    meta: {"permissions":["billing_invoice:read"]}
  },

  "/app/postpaid-billing": {
    component: () => import("./pages/postpaid-billing/page.tsx"),
    meta: {"permissionsAny":["billing_invoice:read","billing_run:read"]}
  },

  "/app/postpaid-billing/periods": {
    component: () => import("./pages/postpaid-billing/periods/page.tsx"),
    meta: {}
  },

  "/app/postpaid-billing/runs/:id": {
    component: () => import("./pages/postpaid-billing/runs/[id]/page.tsx"),
    meta: {"permissions":["billing_run:read"]}
  },

  "/app/postpaid-billing/runs": {
    component: () => import("./pages/postpaid-billing/runs/page.tsx"),
    meta: {"permissions":["billing_run:read"]}
  },

  "/app/prepaid/credit/new": {
    component: () => import("./pages/prepaid/credit/new/page.tsx"),
    meta: {"permissions":["recharge_log:create"]}
  },

  "/app/prepaid/credit/reissue/:failedVendId": {
    component: () => import("./pages/prepaid/credit/reissue/[failedVendId]/page.tsx"),
    meta: {"permissions":["recharge_log:write"]}
  },

  "/app/prepaid/credit-transfers/:id": {
    component: () => import("./pages/prepaid/credit-transfers/[id]/page.tsx"),
    meta: {"permissions":["recharge_log:read"]}
  },

  "/app/prepaid/credit-transfers": {
    component: () => import("./pages/prepaid/credit-transfers/page.tsx"),
    meta: {"permissions":["recharge_log:read"]}
  },

  "/app/prepaid/trace": {
    component: () => import("./pages/prepaid/trace/page.tsx"),
    meta: {"permissions":["recharge_log:read","payment:read"]}
  },

  "/app/profile": {
    component: () => import("./pages/profile/page.tsx"),
    meta: {}
  },

  "/app/reconciliation/flows/:id": {
    component: () => import("./pages/reconciliation/flows/[id]/page.tsx"),
    meta: {}
  },

  "/app/reconciliation/flows": {
    component: () => import("./pages/reconciliation/flows/page.tsx"),
    meta: {}
  },

  "/app/reconciliation/runs/:id": {
    component: () => import("./pages/reconciliation/runs/[id]/page.tsx"),
    meta: {}
  },

  "/app/reconciliation/runs": {
    component: () => import("./pages/reconciliation/runs/page.tsx"),
    meta: {}
  },

  "/app/reports/:id": {
    component: () => import("./pages/reports/[id]/page.tsx"),
    meta: {}
  },

  "/app/reports": {
    component: () => import("./pages/reports/page.tsx"),
    meta: {}
  },

  "/reset-password": {
    component: () => import("./pages/reset-password/page.tsx"),
    meta: {"path":"/reset-password","auth":false}
  },

  "/app/signup": {
    component: () => import("./pages/signup/page.tsx"),
    meta: {}
  },

  "/app/sim-cards/:id": {
    component: () => import("./pages/sim-cards/[id]/page.tsx"),
    meta: {"permissions":["sim_card:read"]}
  },

  "/app/sim-cards": {
    component: () => import("./pages/sim-cards/page.tsx"),
    meta: {"permissions":["sim_card:read"]}
  },

  "/app/tariffs/:id": {
    component: () => import("./pages/tariffs/[id]/page.tsx"),
    meta: {"permissions":["billing_tariff:read"]}
  },

  "/app/tariffs": {
    component: () => import("./pages/tariffs/page.tsx"),
    meta: {"permissions":["billing_tariff:read"]}
  },

  "/app/users/:id": {
    component: () => import("./pages/users/[id]/page.tsx"),
    meta: {"permissions":["user:read"]}
  },

  "/app/users/create": {
    component: () => import("./pages/users/create/page.tsx"),
    meta: {"permissions":["users:create"]}
  },

  "/app/users": {
    component: () => import("./pages/users/page.tsx"),
    meta: {"permissions":["user:read"]}
  },

  "/app/workspaces/data": {
    component: () => import("./pages/workspaces/data/page.jsx"),
    meta: {"roles":["Data Manager","System Manager"]}
  },

  "/app/workspaces/data-quality-exceptions": {
    component: () => import("./pages/workspaces/data-quality-exceptions/page.tsx"),
    meta: {"roles":["Data Manager","System Manager"]}
  },

  "/app/workspaces/payments": {
    component: () => import("./pages/workspaces/payments/page.tsx"),
    meta: {"permissionsAny":["payment:read","payment_allocation:read","mpesa_setting:read"]}
  },

  "/app/workspaces/reporting": {
    component: () => import("./pages/workspaces/reporting/page.jsx"),
    meta: {"roles":["Report Manager","Report Viewer","System Manager"]}
  },

  "/app/workspaces/usage-insights/anomalies": {
    component: () => import("./pages/workspaces/usage-insights/anomalies/page.jsx"),
    meta: {}
  },

  "/app/workspaces/usage-insights/consumption-trends": {
    component: () => import("./pages/workspaces/usage-insights/consumption-trends/page.jsx"),
    meta: {}
  },

  "/app/workspaces/usage-insights/latest-readings": {
    component: () => import("./pages/workspaces/usage-insights/latest-readings/page.jsx"),
    meta: {"roles":["Data Manager","Data Viewer","System Manager"]}
  },

  "/app/workspaces/usage-insights": {
    component: () => import("./pages/workspaces/usage-insights/page.jsx"),
    meta: {"roles":["Data Manager","Data Viewer","System Manager"]}
  },

  "/app/workspaces/usage-insights/peak-analysis": {
    component: () => import("./pages/workspaces/usage-insights/peak-analysis/page.jsx"),
    meta: {}
  },

  "/app/workspaces/usage-insights/telemetry": {
    component: () => import("./pages/workspaces/usage-insights/telemetry/page.jsx"),
    meta: {"roles":["Data Manager","Data Viewer","System Manager"]}
  },
};

export default pageRegistry;
